import { observable } from 'mobx';

export default class PersonStatusStore {
	@observable pendingPersons: Map<string, { isPending: boolean, errorMessage?: string }> = new Map();
    private _subscribers: (() => void)[] = [];

    public updatePersonStatus(personId: string, isPending: boolean, errorMesage?: string){
        if (isPending){
            this.pendingPersons.set(personId, { isPending: true, errorMessage: errorMesage });
        } else {
            this.pendingPersons.set(personId, { isPending: false });
        }
        this._subscribers.forEach(s => s());
    }

    public subscribeOnChage(callback: () => void){
        this._subscribers.push(callback);
    }
    
    public unSubscribeOnChage(callback: () => void){
        this._subscribers = this._subscribers.filter(x => x !== callback);
    }
}

export const personStatusStore = new PersonStatusStore();